"use strict"

import React from "react"
import { Button } from "react-bootstrap"

import { isLTPM } from "../../../../../components/shared_components_registration"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  add_gridlines_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.add.gridlines" }) : "Add Gridlines",
}

export default function ToggleGridlinesButton({ op, plotEntry, intl, small }) {
  return (
    !["heatmap"].includes(op?.special) && (
      <Button
        variant={"outline-primary"}
        className={`${op.gridlines ? "btn-selected" : ""}${small ? " btn-sm" : ""}`}
        title={registration["add_gridlines_label"](intl)}
        onClick={(e) => {
          e.preventDefault()
          const grid_graph = Object.assign({}, op)
          grid_graph.gridlines = !op.gridlines
          plotEntry.plotConfigUpdater(grid_graph)
        }}
      >
        <span className={"fa fa-th"} aria-hidden={"true"} />
      </Button>
    )
  )
}
